module.exports = __webpack_public_path__ + "media/images/of3-5703e9cb2a792b8b50416e5e2c8d53ef.jpg";